import { lazyLoad } from 'app/utils/loadable';

export const Main = lazyLoad(
  () => import('./main'),
  (module) => module.Main
);
